<template>
  <div class="bk-blokkli-item-options-date">
    <input
      v-model="text"
      type="datetime-local"
      :placeholder="label"
      :min
      :max
    />
  </div>
</template>

<script setup>
import { computed } from "#imports";
const props = defineProps({
  label: { type: String, required: true },
  min: { type: String, required: false, default: "" },
  max: { type: String, required: false, default: "" },
  modelValue: { type: String, required: false, default: "" }
});
const emit = defineEmits(["update:modelValue"]);
const text = computed({
  get() {
    return props.modelValue || "";
  },
  set(v) {
    emit("update:modelValue", (v === void 0 ? "" : v).toString());
  }
});
</script>

<script>
export default {
  name: "OptionsFormText"
};
</script>
